import SettingsIcon from '../settings-icon.vue'
import $audit_settings from 'stores/audit-settings'
import {AUDIT_TOKEN, API_AUDIT_LOGS} from 'consts/api'
import {API2_AUDIT_GROUPS, API2_AUDIT_USERS} from 'consts/api2'

import {Rest} from 'utils'

const __default__ = {
  data() {
    return {
      rest: new Rest({auth: false}),
      data_loading: false,
      data: []
    }
  },
  computed: {
    loading() {
      return !$audit_settings.loaded
    },
    client_id() {
      return $audit_settings.client_id
    },
    client_secret() {
      return $audit_settings.client_secret
    }
  },
  async mounted() {
    await $audit_settings.load()
  },
  methods: {
    async onClientAction(event) {
      this.$refs.confirm.open(event.target.name)
    },
    async onDeleteClient() {
      await $audit_settings.deleteClient()
    },
    async onCreateClient() {
      await $audit_settings.createClient()
    },
    async authHeaders() {
      const token_resp = await this.rest.post(
        AUDIT_TOKEN, new URLSearchParams({grant_type: 'client_credentials'}), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Basic ${btoa(`${this.client_id}:${this.client_secret}`)}`
          }
        }
      )
      return {
        'Authorization': `Bearer ${token_resp.access_token}`
      }
    },
    async onFetchGroups() {
      this.data_loading = true
      const headers = await this.authHeaders()
      const resp = await this.rest.get(API2_AUDIT_GROUPS, {limit: 10}, {headers})
      this.data = resp.groups
      this.data_loading = false
    },
    async onFetchUsers() {
      this.data_loading = true
      const headers = await this.authHeaders()
      const resp = await this.rest.get(API2_AUDIT_USERS, {limit: 10}, {headers})
      this.data = resp.users
      this.data_loading = false
    },
    async onFetchLogs(source) {
      this.data_loading = true
      const headers = await this.authHeaders()

      const resp1 = await this.rest.get(API_AUDIT_LOGS, {source: source, after: (new Date(1, 1, 1990)).getTime(), limit: 5}, {headers})
      this.data = resp1.events

      if (resp1.next_token) {
        const resp2 = await this.rest.get(API_AUDIT_LOGS, {limit: 5, next_token: resp1.next_token}, {headers})
        this.data = this.data.concat(resp2.events)
      }

      this.data_loading = false
    }
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'audit-api',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get Rest() { return Rest }, SettingsIcon, get $audit_settings() { return $audit_settings }, get AUDIT_TOKEN() { return AUDIT_TOKEN }, get API_AUDIT_LOGS() { return API_AUDIT_LOGS }, get API2_AUDIT_GROUPS() { return API2_AUDIT_GROUPS }, get API2_AUDIT_USERS() { return API2_AUDIT_USERS } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})